import { FC } from "react";
import { Box, Typography } from "@mui/material";

interface DataRendererProps {
  sx?: any;
  data: Record<string, any> | Record<string, any>[];
}

const formatLabel = (key: string) => {
  return key
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Convert camelCase to "Camel Case"
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
};

const renderField = (label: string, value: any) => {
  if (!value && value !== 0) return null;
  return (
    <>
      <Typography variant="caption" color="text.secondary">
        <strong>{label}:</strong>{" "}
        {typeof value === "number" ? `$${value.toFixed(2)}` : value}
      </Typography>
      <br />
    </>
  );
};

export const SimpleDataBoxRenderer: FC<DataRendererProps> = ({ data, sx }) => {
  const dataArray = Array.isArray(data) ? data : [data];

  return (
    <Box sx={sx}>
      {dataArray.map((item, index) => (
        <Box
          key={index}
          sx={{ mb: 2, p: 1, border: "1px solid #ccc", borderRadius: 1 }}
        >
          {Object.entries(item).map(([key, value]) =>
            renderField(formatLabel(key), value)
          )}
        </Box>
      ))}
    </Box>
  );
};
